<template>
  <div>
    <button v-if="false" type="button" :title="$t('download_manual')"
      class="button is-danger is-inverted is-small is-pulled-right">
      <b-icon icon="cloud-download-alt" />
    </button>
    <h3 class="title is-5" v-t="'title'" />
    <div v-if="$auth.check(['admin', 'support'])" class="has-margin-bottom-md">
      <router-link :to="{ name: 'new-article' }" class="button is-danger is-fullwidth">
        <b-icon icon="plus" size="is-small" />
        <span v-t="'new_article'" />
      </router-link>
    </div>	
    <div class="vertical-tabs" v-if="!isLoading">
      <router-link
        :to="{ name: 'manual' }"
        class="tab"
        v-t="'faq'"
        exact />

      <router-link class="tab"
        v-if="article.advanced === false || !$auth.check('customer')"
        v-for="(article, index) in articles" :key="index"
        :to="{ name: 'article', params: { article: article.slug } }"
        exact>
        {{ article.title }}
      </router-link>
    </div>
    <loading-content v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingContent from './LoadingContent'

export default {
  name: 'ArticlesIndex',
  props: { product: { type: Object, required: true } },
  components: { LoadingContent },
  mounted () {
    this.fetchArticles(this.product.id)
  },
  watch: {
    product () {
      this.fetchArticles(this.product.id)
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'article/isLoading',
      articles: 'article/articles'
    })
  },
  methods: {
    ...mapActions({ fetchArticles: 'article/fetchArticles' })
  }
}
</script>

<style lang="sass" scoped>
.vertical-tabs .tab
  display: block
  padding: 1rem 1.25rem
  border-left: 4px solid $white-ter
  color: $grey-darker
  font-weight: 700
  &:hover,
  &:focus
    border-left-color: $grey-lighter
  &.is-active
    border-left-color: $red
</style>

<i18n>
{
  "en-US": {
    "title": "Index",
    "download_manual": "Download complete PDF manual",
    "new_article": "New Article",
    "faq": "Frequently Asked Questions"
  },
  "pt-BR": {
    "title": "Índice",
    "download_manual": "Baixar manual completo em PDF",
    "new_article": "Novo Artigo",
    "faq": "Dúvidas Frequentes"
  }
}
</i18n>
